<template>
	<div class="cour">
		<div class="x"></div>
		<div class="tab">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="资料设置" name="first">
					<el-form ref="form" :rules="rules" :model="form" label-width="100px">
						<el-form-item label="姓名">
							<el-input v-model="form.nickname" placeholder="请输入真实姓名" :readonly='true'></el-input>
						</el-form-item>
						<el-form-item label="联系电话" prop="mobile">
							<el-input v-model="form.mobile" placeholder="为确保联系到本人，请准确填写有效手机号"></el-input>
						</el-form-item>
						<el-form-item label="身份证号码">
							<el-input v-model="form.card" placeholder="为确保证书合法有效，请准确填写本人身份证件信息" :readonly='true'>
							</el-input>
						</el-form-item>
						<el-form-item label="单位名称">
							<el-input v-model="form.company" placeholder="请准确填写工作单位信息（用于生成证书）" :readonly='true'>
							</el-input>
						</el-form-item>
						<!-- <el-form-item label="教育类型" v-if="form.group_id ===1">
							<el-input v-model="form.learning_type_text" placeholder="请准确填写工作单位信息（用于生成证书）"
								:readonly='true'></el-input>
							 <el-select v-model="form.learning_type" placeholder="请选择教育类别" style="width: 100%;">
								<el-option v-for="item in Learningdata" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item> -->
						<el-form-item label="个人免冠照">
							<el-upload class="avatar-uploader" :action="fileimg.uploadUrl" :show-file-list="false"
								:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
								<img v-if="form.picture" :src="cdnurl+form.picture" class="avatar" />
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
							<div class="upload-but">
								<div>
									<p style="color: #FF0000;">照片上传注意事项</p></br>
									<p>上传电子版照片为近期免冠正面证件照，格式为jpg，大小为50K～100k，2寸照片。</p></br>
									<p>照片必须清晰反映本人特征，
										<span style="color: #FF0000;">如生活照、照片模糊或虚、红‘X’等情况，</span>
										均不能通过照片审核ss
									</p></br>
								</div>
							</div>
						</el-form-item>

						<el-form-item>
							<el-button type="primary" size="medium" @click="onSubmit('form')">立即保存</el-button>
						</el-form-item>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="修改密码" name="second">
					<el-form ref="formpwd" :rules="pwdrules" :model="formpwd" label-width="100px">
						<el-form-item label="旧密码" prop="pwd">
							<el-input v-model="formpwd.pwd" placeholder="请输入原密码" show-password></el-input>
						</el-form-item>
						<el-form-item label="新密码" prop="pwd1">
							<el-input v-model="formpwd.pwd1" placeholder="请输入新密码" show-password></el-input>
						</el-form-item>
						<el-form-item label="确认密码" prop="pwd2">
							<el-input v-model="formpwd.pwd2" placeholder="请输入确认新密码" show-password></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" size="medium" @click="submitForm('formpwd')">立即提交</el-button>
						</el-form-item>
					</el-form>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeName: 'first',
				form: {
					nickname: '',
					mobile: '',
					card: '',
					company: '',
					learning_type_text: '',
					type: [],
					resource: '',
					desc: '',
					picture: ''
				},
				rules: {
					mobile: [{
						required: true,
						pattern: /^1\d{10}$/,
						message: '请输入正确的手机号',
						trigger: 'blur'
					}],
				},
				formpwd: {
					pwd: '',
					pwd1: '',
					pwd2: ''
				},
				pwdrules: {
					pwd: [{
						required: true,
						message: '请输入旧密码',
						trigger: 'blur'
					}],
					pwd1: [{
						required: true,
						message: '请输入新密码',
						trigger: 'blur'
					}],
					pwd2: [{
						required: true,
						message: '请输入确认新密码',
						trigger: 'blur'
					}],
				},
				fileimg: {
					uploadUrl: this.$uploadApi,
				},
				cdnurl: this.$https,
				imageUrl: '',
				userInfos: {},
				Learningdata: []
			};
		},
		created() {
			this.form = JSON.parse(sessionStorage.getItem('userInfo'))
			console.log(this.form)
			this.getLearningType()
		},
		methods: {
			//获取教育类别
			getLearningType() {
				this.$http({
						method: 'POST',
						url: '/index/getLearningType',
						headers: {
							requireAuth: false // 这里通过设置requireAuth为true来启用token检查
						},
					})
					.then(response => {
						if (response.code == 1) {
							this.Learningdata = response.data
						} else {
							this.$message(response.msg);
						}

					})
					.catch(error => {
						console.log(error)
					})
			},
			//修改个人资料
			onSubmit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$http({
								method: 'POST',
								url: '/user/upUser',
								headers: {
									requireAuth: true // 这里通过设置requireAuth为true来启用token检查
								},
								data: {
									mobile: this.form.mobile,
									picture: this.form.picture
								}
							})
							.then(response => {
								if (response.code == 1) {
									let userinfo = JSON.parse(sessionStorage.getItem('userInfo'));
									userinfo.mobile = this.form.mobile;
									userinfo.picture = this.form.picture;
									sessionStorage.setItem('userInfo', JSON.stringify(userinfo));
									this.$message({
										message: response.msg,
										type: 'success'
									});
								} else {
									this.$message(response.msg);
								}
							})
							.catch(error => {
								console.log(error)
							})
					}

				})
			},
			//修改密码
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.formpwd.pwd1 === this.formpwd.pwd2) {
							this.$http({
									method: 'POST',
									url: '/user/newresetpwd',
									headers: {
										requireAuth: true // 这里通过设置requireAuth为true来启用token检查
									},
									data: {
										oldpassword: this.formpwd.pwd,
										newpassword: this.formpwd.pwd1
									}
								})
								.then(response => {
									if (response.code == 1) {
										this.$message({
											message: response.msg,
											type: 'success'
										});
										this.formpwd = {
											pwd: '',
											pwd1: '',
											pwd2: ''
										}
										sessionStorage.clear()
										this.$router.replace({
											name: 'login'
										})
									} else {
										this.$message.error(response.msg);
									}
								})
								.catch(error => {
									console.log(error)
								})
						} else {
							this.$message('两次密码输入不一致！');
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},

			handleClick(tab, event) {
				console.log(tab, event);
			},
			//上传证件照
			handleAvatarSuccess(res, file) {
				this.imageUrl = URL.createObjectURL(file.raw);
				this.form.picture = file.response.data.url
				console.log(file.response.data.url)
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 124 < 1;
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
					return isJPG && isLt2M;
				}
				if (!isLt2M) {
					console.log(isLt2M)
					this.$message.error('上传头像图片大小不能超过 100KB!');
					return isJPG && isLt2M;
				}
			},
		}
	};
</script>

<style scoped>
	/* 我的*/
	.upload-but {
		line-height: 16px;
		float: left;
		margin-top: 20px;
		margin-left: 10px;
	}

	.upload-img {
		width: 120px;
		height: 158px;
		float: left;
		border: 1px solid #eee;
	}

	.upload-img img {
		width: 120px;
		height: 158px;

	}

	.avatar-uploader {
		width: 160px;
		float: left;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		border: 1px solid #d9d9d9;
		color: #8c939d;
		width: 140px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 142px;
		height: 178px;
		display: block;
	}

	/deep/.el-tabs__item {
		font-size: 16px !important;
	}

	ul {
		margin: 0 !important;
		padding: 0 !important;
	}

	.cour {
		width: 99%;
		margin-left: 10px;
		height: calc(100vh - 300px);
		background: #FFFFFF;
		border: 1px solid rgba(0, 0, 0, 0.07);
	}

	.x {
		width: 100%;
		border-top: 5px solid rgba(38, 117, 197, 1);
	}

	.tab {
		width: 98%;
		margin: 5px auto;
	}
</style>
